<template>
  <div class="generic-search-list-search-bar">
    <input
      class="search-input icon-search"
      :placeholder="searchPlaceholder"
      value=""
      @input="[triggerFilter($event), trackInput($event)]"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { debounce } from '@utils/timing'

  export default {
    name: 'generic-list-search-bar',
    computed: {
      ...mapGetters('i18n', ['tc'])
    },
    inject: ['searchPlaceholder'],
    methods: {
      triggerFilter(val) {
        this.$emit('filter-items', val.currentTarget.value, 'input')
      },
      trackInput: debounce(function (val) {
        this.$track({ event: 'inputSearch', value: val.target.value })
      }, 300)
    }
  }
</script>
